module.exports = __webpack_public_path__ + "media/images/cta-target-icon-9b849e93d6428248db8f3614cfcd9e24.png";